import { combineReducers } from '@reduxjs/toolkit'
import {
	orderEditSlice,
	ordersListSlice,
	documentSlice,
	productsSlice,
	tariffsSlice,
	okvedsSlice,
	infotecsSlice,
	fnsSlice,
	drsSlice,
	ustavSlice,
	sberGeoAddressSlice,
	patentsSlice,
	outOfficeRegistratorCabinetSlice,
} from './slices'

export * from './slices'
export * from './selectors'
export * from './sagas'

export const registratorCabinetReducers = combineReducers({
	[ordersListSlice.name]: ordersListSlice.reducer,
	[orderEditSlice.name]: orderEditSlice.reducer,
	[documentSlice.name]: documentSlice.reducer,
	[productsSlice.name]: productsSlice.reducer,
	[tariffsSlice.name]: tariffsSlice.reducer,
	[okvedsSlice.name]: okvedsSlice.reducer,
	[infotecsSlice.name]: infotecsSlice.reducer,
	[fnsSlice.name]: fnsSlice.reducer,
	[drsSlice.name]: drsSlice.reducer,
	[ustavSlice.name]: ustavSlice.reducer,
	[sberGeoAddressSlice.name]: sberGeoAddressSlice.reducer,
	patents: patentsSlice,
	[outOfficeRegistratorCabinetSlice.name]: outOfficeRegistratorCabinetSlice.reducer,
})

export const registratorCabinetActions = {
	...ordersListSlice.actions,
	...orderEditSlice.actions,
	...documentSlice.actions,
	...productsSlice.actions,
	...tariffsSlice.actions,
	...okvedsSlice.actions,
	...infotecsSlice.actions,
	...fnsSlice.actions,
	...drsSlice.actions,
	...ustavSlice.actions,
	...sberGeoAddressSlice.actions,
	...outOfficeRegistratorCabinetSlice.actions,
}
